import { defineFurniture } from './types.js';
import type { FurnitureDef } from './types.js';

/**
 * A swimming pool, built the same way as the running track: single-tile
 * pieces (water, straight coping, corner coping, plain deck) placed edge to
 * edge into any size or shape. Category 'pool'.
 */
export const POOL_FURNITURE: Record<string, FurnitureDef> = defineFurniture('pool', {
  pool_water: {
    label: 'Pool Water',
    description: 'Cool, chlorinated blue. Step in for a swim.',
    price: 40,
    solid: false,
    height: 0,
    water: true,
  },
  pool_edge_straight: {
    label: 'Pool Coping (Straight)',
    description: 'The tiled lip around the water. Lay it along an edge.',
    price: 30,
    solid: false,
    height: 0,
  },
  pool_edge_corner: {
    label: 'Pool Coping (Corner)',
    description: 'Turns the pool edge 90°. Rotate to match your shape.',
    price: 30,
    solid: false,
    height: 0,
  },
  pool_deck: {
    label: 'Pool Deck',
    description: 'Sun-warmed tiles for lounging poolside.',
    price: 20,
    solid: false,
    height: 0,
  },
});
